import React from "react"
import "./TagLoaders.css"

type LoaderVariant = "spinner" | "pulse" | "dots" | "bars" | "ring"

interface TagLoadersProps {
    tags: string[]
    message: string
    variant?: LoaderVariant   // 👈 NEW (optional)
}

const getColor = (index: number) => {
    const colors = [
        "#3b82f6",
        "#22c55e",
        "#f59e0b",
        "#a855f7",
        "#ef4444",
    ]
    return colors[index % colors.length]
}

const LoaderGraphic = ({
    variant,
    color,
}: {
    variant: LoaderVariant
    color: string
}) => {
    switch (variant) {
        case "spinner":
            return (
                <div
                    className="loader-spinner"
                    style={{ borderTopColor: color }}
                />
            )

        case "pulse":
            return (
                <div
                    className="loader-pulse"
                    style={{ backgroundColor: color }}
                />
            )

        case "dots":
            return (
                <div className="loader-dots">
                    <span style={{ backgroundColor: color }} />
                    <span style={{ backgroundColor: color }} />
                    <span style={{ backgroundColor: color }} />
                </div>
            )

        case "bars":
            return (
                <div className="loader-bars">
                    <span style={{ backgroundColor: color }} />
                    <span style={{ backgroundColor: color }} />
                    <span style={{ backgroundColor: color }} />
                </div>
            )

        case "ring":
            return (
                <svg
                    className="loader-ring"
                    viewBox="0 0 50 50"
                    width="32"
                    height="32"
                >
                    <circle
                        cx="25"
                        cy="25"
                        r="20"
                        stroke={color}
                        strokeWidth="4"
                        fill="none"
                        strokeDasharray="100"
                        strokeDashoffset="60"
                    />
                </svg>
            )

        default:
            return null
    }
}

export const TagLoaders: React.FC<TagLoadersProps> = ({
    tags,
    message,
    variant = "spinner", // 👈 default
}) => {
    return (
        <div role="status" aria-live="polite" className="tag-loader-container">
            {tags.map((tag, index) => (
                <div key={tag} className="tag-loader-item">
                    <LoaderGraphic
                        variant={variant}
                        color={getColor(index)}
                    />

                    <div className="tag-loader-text">
                        <strong>{tag}</strong>
                        <span>{message}</span>
                    </div>
                </div>
            ))}
        </div>
    )
}
